import { Box, Button, CircularProgress } from "@mui/material";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ReplayIcon from '@mui/icons-material/Replay';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
// import CustomAlert from "./Components/CustomAlert";
import axios from "axios";
import host, { Host } from "../../../assets/js/Host";
import AlertComponent from "./Components/AlertComponent";
import VerificationStep from "./Components/VerificationStep";


export default function CallBackComponent() {
  const urlParams = new URLSearchParams(window.location.search);
  const orderID = urlParams.get("orderId")||urlParams.get("OrderId");
  const status = urlParams.get("status");
  const checkoutId=urlParams.get('checkoutId')

  const text=(status=="DEPOSITED")?"يرجى الانتظار بينما يتم تحميل الوصل الخاص بك...":"يرجى الانتظار بينما يتم تحميل التحقق..."
  const lang = urlParams.get("lang");
  const ACD = urlParams.get("ACD");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const object = {
    orderId: orderID,
    status: status,
    lang: lang,
    ACD: ACD,
    checkoutId:checkoutId
  };
  const [showPayment, setShowPayment] = useState(false);
  const [statusData, setStatusData] = useState(null);
  const mainTheme ={
    mainColor:"#1e6a99"
  };
  const [guestToken, setGuestToken] = useState(null);
  const [orderData, setOrderData] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [statusValue,setStatusValue]=useState(status)
  const [showAlert, setShowAlert] = useState(false);
  const [registerCaptchaValue, setRegisterCaptchaValue] = useState(null);
  const [isCapatchTrue, setIsCapatchTreu] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState("");
  const registerCaptchaRef = useRef();
  const captchaRef = useRef(null);
  const [showLaterPopup,setShowLaterPopup]=useState(false);
  
  const reloadCapatch = (e, number = 1) => {
    if (number == 2) {
      if (registerCaptchaRef && registerCaptchaRef?.current) {
        registerCaptchaRef?.current.reset();
      }
    } else {
      if (captchaRef && captchaRef?.current) {
        captchaRef?.current.reset();
      }
    }
    setIsCapatchTreu(false);
    setRecaptchaValue(null);
    setRegisterCaptchaValue(null)
  };
  // console.log("EbppCallBack=====>", object);
  //in this function, I will,l update the register order status + generate the receipt number for this order if it is deposited successfully.
  const updateRegisterOrderStatus = async () => {
    try {
      if (!orderID) {
        toast.warn("معرف الطلب غير موجود");
        return;
      }
      setLoading(true);
      const data = await axios({
        method:'post',
        url:host+"get_register_order_status",
        data:object
      }) 
      console.log("asdsadsadas", data?.data); 
      setLoading(false);
      if (data && data?.status) {
        if (data?.data?.success) {
          setShowPayment(false);
          setStatusData(data?.data?.data);
          handleStatusMessage(
            data?.data?.data?.data?.paymentAmountInfo?.paymentState
          );
          setStatusValue(data?.data?.data?.data?.paymentAmountInfo?.paymentState)
          setInvoiceData(data?.data?.data?.invoice)
        } else {
          if (data?.data?.data && typeof data?.data?.data == "string") {
            toast.warn(data?.data?.data);
          } else {
            toast.warn("خطء غير معروف ");
          }
        }
      } else {
        if (data?.data?.data && typeof data?.data?.data == "string") {
          toast.warn(data?.data?.data);
        } else {
          toast.warn("خطء غير معروف ");
        }
      }
    } catch (err) {
      const response=err?.response?.data?.data
      console.log('asdasdasdasd===>',response)
      setLoading(false);
      if(response&&typeof response=="string")
        toast.error(response);
      else
       toast.warn("خطء غير معروف ");

    }
  };
  useEffect(() => {
    if (localStorage.getItem("registerOrderData")) {
      localStorage.removeItem("registerOrderData");
    }
    handleStatusMessage(status);
    updateRegisterOrderStatus()
  }, []);
  const handleStatusMessage = (status) => {
    let message = "";
    if (status == "DEPOSITED") {
      message = "تم الايداع بنجاح";
    } else if (status == "CREATED") {
      message = "تم تسجيل الطلب بنجاح،وفي انتضار الموافقة على حركة المشتريات";
    } else if (status == "APPROVED") {
      message = "تم الموافقة على حركة المشتريات";
    } else if (status == "DECLINED") {
      message = "تم رفض عملية الايداع";
    } else if (status == "REVERSED") {
      message = "تم التراجع عن الدفعة التي تم الموافقة عليها مسبقا";
    } else if (status == "REFUNDED") {
      message = "تم اعادت الاموال اليك!";
    }
    setMessage(message);
  };
  const handleReturnImage = () => {
    let status = statusData?.data?.paymentAmountInfo?.paymentState
      ? statusData?.data?.paymentAmountInfo?.paymentState
      : object?.status;
    let ImageSrc = null;
    if (status == "DEPOSITED") {
      ImageSrc = require("../../../assets/img/success.png");
    } else if (status == "CREATED") {
      ImageSrc = require("../../../assets/img/success.png");
    } else if (status == "APPROVED") {
      ImageSrc = require("../../../assets/img/success.png");
    } else if (status == "DECLINED") {
      ImageSrc = require("../../../assets/img/remove.png");
    } else if (status == "REVERSED") {
      ImageSrc = require("../../../assets/img/warning.png");
    } else if (status == "REFUNDED") {
      ImageSrc = require("../../../assets/img/warning.png");
    }
    return ImageSrc;
  };
  const handleRegisterInvoice = async () => {
    if (!registerCaptchaValue) {
      return toast.warn("يجب عليك التحقق من كونك لستة رجل آلي");
    }

    if (!invoiceData || !invoiceData.id) {
      toast.warn("معرف الطلب غير موجود");
      return;
    }
    setLoading(true);
    var data = null;
    setShowAlert(false);
    const newWindow = window.open('', '_blank');
    
    try {
      // Verify captcha and process payment
      const response = await axios.post(`${host}guest_register_by_invoice_number`, {
        invoice_id: invoiceData.id,
          captcha_token: registerCaptchaValue,
      });
      setLoading(false);
      if (response.data && response.data.success) {
        toast.success('Payment processed successfully!');
        // Redirect to payment gateway or success page
        // Open the window immediately on user click, before the async operation
        if (response?.data?.data?.data?.formUrl) {
          newWindow.location.href = response.data.data.data.formUrl;
        }else{
          newWindow.close(); // Close if no URL received
        }
      }else if(response.data?.data&&typeof response.data.data === 'string') {
         newWindow.close(); // Close if no URL received
        toast.error(response.data.data)
      }else {
        newWindow.close(); // Close if no URL received
        toast.error("فشل في معالجة الدفع. يرجى المحاولة مرة أخرى.");
      }

    } catch (err) {
      newWindow.close(); // Close if no URL received
      // console.error('Payment error:', err);
      toast.error("فشل في معالجة الدفع. يرجى المحاولة مرة أخرى.");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadPDF = async () => {
    if (!invoiceData || !invoiceData.id) {
      toast.warn("معرف الفاتورة غير موجود");
      return;
    }

    try {
      setLoading(true);
      
      // Alternative approach: Use window.open with download attribute
      // This bypasses CORS issues for file downloads
      const downloadUrl = `${host}invoices/${orderID}/receipt/pdf/download`;
      
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `receipt_${orderID}.pdf`;
      link.target = '_blank';
      
      // Add to DOM, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      toast.success('تم بدء تحميل الوصل');
      
    } catch (err) {
      // console.error('Download error:', err);
      toast.error(`فشل في تحميل الوصل: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Alternative download method using fetch with proper CORS handling
  const handleDownloadPDFWithFetch = async () => {
    if (!invoiceData || !invoiceData.id) {
      toast.warn("معرف الفاتورة غير موجود");
      return;
    }

    try {
      setLoading(true);
      // console.log('Downloading PDF from:', `${host}invoices/${invoiceData.id}/receipt/pdf/download`);
      
      const response = await fetch(`${host}invoices/${orderID}/receipt/pdf/download`, {
        method: 'GET',
        headers: {
          'Accept': 'application/pdf',
          'Content-Type': 'application/pdf'
        },
        mode: 'cors', // Explicitly set CORS mode
        credentials: 'include' // Include credentials if needed
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      
      // Check if response is actually a PDF
      if (blob.type && !blob.type.includes('pdf')) {
        // console.error('Response is not a PDF:', blob.type);
        const text = await blob.text();
        // console.error('Response content:', text);
        toast.error('الاستجابة ليست ملف PDF صالح');
        return;
      }

      // Create blob link to download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `receipt_${orderID}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success('تم تحميل الوصل بنجاح');
    } catch (err) {
      // console.error('Download error:', err);
      if (err.name === 'TypeError' && err.message.includes('CORS')) {
        toast.error('خطأ في الوصول للملف - مشكلة CORS');
      } else {
        toast.error(`فشل في تحميل الوصل: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleViewPDF = async () => {
    if (!invoiceData || !invoiceData.id) {
      toast.warn("معرف الفاتورة غير موجود");
      return;
    }

    try {
      const pdfUrl = `${host}invoices/${orderID}/receipt/pdf/view`;
      window.open(pdfUrl, '_blank');
    } catch (err) {
      // console.error('View error:', err);
      toast.error('فشل في عرض الوصل');
    }
  };
  return (
    <Box
      sx={{
        width: "100%",
        height:'86dvh',
        overflowY:'hidden !important',
        marginTop: "80px",
        backgroundColor:"#f9f9f8",
      }}
    >
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
         gap: "20px",
        flexDirection: "column",
      }}
    >
       {/* {showLaterPopup?
       <CustomAlert 
          addForm={showLaterPopup}
          setAddForm={setShowLaterPopup}
          object={invoiceData}
          guestToken={guestToken}
       />:null} */}
       {showAlert ? (
            <AlertComponent
              open={showAlert}
              setOpen={setShowAlert}
              title={"هل انتة متاكد ؟"}
              body={
                "بمجرد الضغط على موافق, سيتم دفع الطلب عبر بوابة الدفع االكترونية"
              }
              hasExtraContent={true}
              extraContent={() => {
                return <VerificationStep
                  setRecaptchaValue={setRegisterCaptchaValue}
                  recaptchaValue={registerCaptchaValue}
                  setIsCapatchTreu={() => {}}
                  isCapatchTrue={null}
                  captchaRef={registerCaptchaRef}
                  reloadCapatcha={(e)=>reloadCapatch(e,2)}
                  checkTokenInServer={false}
                />;
              }}
              agreeFunction={() => {
                handleRegisterInvoice();
              }}
              agreeTitle={"موافق"}
              // disAgreeTitle={"كلا"}
              // disAgreeFunction={() => {
              //   exportMultipleOrderINOneFile();
              // }}
              showCloseButton={true}
            />
          ) : null}
      {!loading?<>
        <img
          src={handleReturnImage()}
          style={{
            width: "200px",
            height: "200px",
            objectFit: "contain",
          }}
        />
        <span>{message}</span>
      </> : null}
              {/* <Button
          variant="contained"
          sx={{
            width: "fit-content",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            backgroundColor: "#f3f3f3",
            color: mainTheme?.mainColor,
            "&:hover": {
              backgroundColor: "#f3f3f3",
              color: mainTheme?.mainColor,
            },
          }}
          onClick={() => setShowPayment(true)}
        >
          <span style={{ fontSize: "20px" }}>طباعة وصل القبض</span>
          <img
            src={require("../../assets/img/upload.png")}
            style={{
              width: "30px",
              height: "30px",
              objectFit: "contain",
            }}
          />
        </Button> */}
      {statusValue == "DEPOSITED" && !loading && invoiceData ? (
        <Box sx={{display:'flex',gap:'20px',alignItems:'center',justifyContent:'center',flexWrap:'wrap'}}>
          <Button
            variant="contained"
            sx={{
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              backgroundColor: mainTheme?.mainColor,
              color: "white",
              "&:hover": {
                backgroundColor: mainTheme?.mainColor,
                opacity: 0.9,
              },
            }}
            onClick={handleDownloadPDF}
            disabled={loading}
          >
            <span style={{ fontSize: "18px" }}>تحميل وصل القبض</span>
            <DownloadIcon sx={{fontSize:'24px'}}/>
          </Button>
          <Button
            variant="outlined"
            sx={{
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              borderColor: mainTheme?.mainColor,
              color: mainTheme?.mainColor,
              "&:hover": {
                borderColor: mainTheme?.mainColor,
                backgroundColor: "rgba(30, 106, 153, 0.04)",
              },
            }}
            onClick={handleViewPDF}
          >
            <span style={{ fontSize: "18px" }}>عرض وصل القبض</span>
            <VisibilityIcon sx={{fontSize:'24px'}}/>
          </Button>
        </Box>
      ) : statusValue != "DEPOSITED" && !loading ? (
        <Box sx={{display:'flex',gap:'20px',alignItems:'center',justifyContent:'center',flexWrap:'wrap'}}>
          <Button
            variant="contained"
            sx={{
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              backgroundColor: "#f3f3f3",
              color: mainTheme?.mainColor,
              "&:hover": {
                backgroundColor: "#f3f3f3",
                color: mainTheme?.mainColor,
              },
            }}
            onClick={() => setShowAlert(true)}
          >
            <span style={{ fontSize: "20px" }}>اعد المحاولة</span>
            <ReplayIcon sx={{fontSize:'40px',color:"#fecfcc"}}/>
          </Button>
          {/* <Button
            variant="contained"
            sx={{
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              backgroundColor: "#f3f3f3",
              color: mainTheme?.mainColor,
              "&:hover": {
                backgroundColor: "#f3f3f3",
                color: mainTheme?.mainColor,
              },
            }}
            onClick={() =>{
              setShowLaterPopup(true)
            }}
          >
            <span style={{ fontSize: "20px" }}>اعد المحاولة في وقتا لاحق!</span>
            <WatchLaterIcon sx={{fontSize:'40px',color:"#fecfcc"}}/>
          </Button> */}
        </Box>
      ) : loading ? (<>
        <CircularProgress size={30} />
        <span>{text}</span>
        </>
      ) : null}
      </Box>
    </Box>
  );
}
